import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { Controller } from 'react-hook-form';
import DropdownSelect from '../../../../../styledComponents/styles/DropdownSelect.styled';
import { fetchAllOrganization, fetchOrganization } from '../../../../../actions/authActions';
import _get from 'lodash/get';
import _lowerCase from 'lodash/lowerCase';
import ScreenReaderHeadingComponent from '../../../../travelerProfile/components/heading/ScreenReaderHeadingComponent';


const Action = styled.div`
  color: #373737;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
  margin: 90px;
  padding-bottom: 50px;
  position: absolute;
  text-decoration: underline;
`;

const Header = styled.span`
  color: #0b3544;
  font-size: 28px;
  font-weight: 600;
  line-height: 74px;
`;

const Instructions = styled.div`
  color: #373737;
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  text-align: center;

  span {
    font-weight: 600;
  }
`;

const InputContainer = styled.div`
  flex: 1;
  margin: 13px 0;
  text-align: left;
`;

// Step 3.
export default function OrgStep(props) {
  let { control, errors, setValue, getValues, isValid } = props;
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const [selectedOrg, setSelectedOrg] = useState(false);
  const [allOrgOptions, setAllOrgOptions] = useState();
  const [selectedOrgValue, setSelectedOrgValue] = useState();
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const orgId = getValues('organizationId');
    const orgName = getValues('organizationName');

    if (orgId && orgName) {
      setSelectedOrgValue({ label: auth.organization.org_name, value: auth.organization.id });
      setSelectedOrg(true);
      setLoading(false);
    } else {
      dispatch(fetchAllOrganization());
      setSelectedOrg(false);
    }
  }, []);

  const handleChangeOrg = () => {
    setSelectedOrg(false);
    dispatch(fetchAllOrganization());
  };

  useEffect(
    () => {
      if (auth && auth.organizations && auth.organizations.length > 0) {
        const filteredOrganizations = auth.organizations
          .filter(organization => !organization.hidden)
          .filter(organization => organization.status !== 'free' && organization.status !== 'lead')
          .filter(organization => organization.allow_traveler_sign_up);
        const orgOptions = filteredOrganizations.map(org => ({
          label: `${org.org_name}`,
          value: org.id,
          fullName: `${org.org_name} [${_lowerCase(org.subdomain)}]`,
          status: org.status,
          subdomain: org.subdomain,
        }));
        setAllOrgOptions(orgOptions);

        setLoading(false);
      }
    },
    [auth],
  );

  return (
    <>

      <ScreenReaderHeadingComponent text={selectedOrg ? 'Verify your organization' : 'Select your organization'} />
      <Header>{selectedOrg ? 'Verify your organization' : 'Select your organization'}</Header>
      {!selectedOrg && <Instructions>Type to select your organization</Instructions>}
      <Controller
        control={control}
        name={'organizationId'}
        render={({ field: { onChange, defaultValue, value, name, ref, ...rest } }) => (
          <InputContainer>
            {!loading && (
              <DropdownSelect
                defaultValue={selectedOrgValue}
                errorMsg={_get(errors.organizationId, 'message') || ''}
                id={'organizationId'}
                isDisabled={selectedOrg}
                label={`Select your organization`}
                required={true}
                tabIndex="0"
                openSans
                options={allOrgOptions}
                placeholder={'Type to select organization'}
                fontColor={"#043544"}
                fontWeight={"600"}
                onChange={value => {
                  const selItem = allOrgOptions.filter(option => option.value === value);
                  dispatch(fetchOrganization(selItem[0].subdomain));
                  setValue('organizationId', selItem[0].value, {
                    shouldValidate: true,
                    shouldTouch: true,
                  });
                  setValue('organizationName', selItem[0].label, {
                    shouldValidate: true,
                    shouldTouch: true,
                  });
                  onChange(value);
                }}
                {...rest}
              />
            )}
          </InputContainer>
        )}
      />
      {selectedOrg && (
        <Action>
          <a
            href='#'
            onClick={handleChangeOrg}
            onKeyDown={keyEvent => {
              if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
                handleChangeOrg();
              }
            }}
            style={{
              color: "unset",
              textDecoration: "unset",
              backgroundColor: "unset"
            }}
          >
            Change organization
          </a>
        </Action>
      )}
    </>
  );
}
